import React, { useContext, useEffect, useState } from "react";
import { trackPageView } from "../../../utils/adobeAnalytics";
import AppContext from "../../AppContext";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel/RightPanel";
import LogService from "../../../utils/logs";
import constants from "../../../config/constants";
import "./TableOfContents.css";
import { useHistory } from "react-router";
import { useMobile } from "../../../hooks/useMobile";
import { pushDatatoAdobeLayer } from '../../../analytics/pmiAdobeLog';
const TableOfContents = ({ isAuthenticated, userPermission, hasAccessUntil,hasAccess, isMember, userId }) => {
  const isMobile = useMobile();
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  const [content, setContent] = useState("");
  const [selectedBook, setSelectedBook] = useState("");
  const [openSideBar, setOpenSideBar] = useState(true);

  const history = useHistory();
let subStatus=""
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "tableofcontents page" });
    } else {
      setIsFirstRender(false);
    }
    if (!isAuthenticated) {
      history.push(`/login`);
    } else {
      LogService.logPageVisit({
        contentKey: constants.pageKeys.tableOfContents,
        contentSubType: constants.contentSubTypes.page,
      });
    }
    //Adobe analytics
    if (isAuthenticated) {
 if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
      let loginData = {
        event: 'loggedin',
        eventInfo: 'loggedin',

        user: {
          membershipTier: userPermission?.isMember?.membership,
          membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
          pmiID: userId,
          loginStatus: "<logged in status >",
        },
      }

      let subscriptionStatus = {
        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate: hasAccessUntil.split('T')[0],
          subStatus: subStatus,

        }
      }
      pushDatatoAdobeLayer({ loginData, subscriptionStatus, pageData: false })
    }
  }, []);

  useEffect(() => {
    if (openSideBar) {
      document.getElementById("leftpanel").classList.add("show");
      document.getElementById("table-of-content").classList.remove("show");
      document.getElementById("leftpanel").classList.remove("effect");
    } else {
      document.getElementById("leftpanel").classList.remove("show");
      document.getElementById("table-of-content").classList.add("show");
      document.getElementById("leftpanel").classList.add("effect");
    }
  }, [openSideBar]);

  const openSidePanel = () => {
    if (isMobile) {
      document.getElementById("leftpanel").classList.add("show");
      document.getElementById("table-of-content").classList.remove("show");
      document.getElementById("leftpanel").classList.remove("effect");
    }
    setOpenSideBar(true);
  };

  return (
    <div className="flex flex-col">
      <div className="contianer mt-20">
        <div className="columns-2 flex w-full h-full">
          <LeftPanel
            setContent={setContent}
            selectedBook={selectedBook}
            setSelectedBook={setSelectedBook}
            setOpenSideBar={setOpenSideBar}
            openSideBar={openSideBar}
          />
          <div
            id={"table-of-content"}
            className="table-of-content-tab flex w-64 mb-24 sm:mb-48 justify-center fixed bottom-0 left-0 z-50 transform -rotate-90 cursor-pointer z-30 side-nav-pmbok7"
            style={{ marginBottom: `calc(100vh - 22rem)` }}
          >
            <div
              className="bg-orange-brand-500 hover:bg-orange-brand-600 text-white text-base rounded-lg shadow-md px-2 py-1 sm:px-4 sm:py-2 border-purple-brand-200 border-2"
              onClick={() => openSidePanel()}
            >
              <span className="hidden sm:inline-block mr-2 align-middle">
                Table of Contents
              </span>
              <span className="inline-block align-middle rotate-90">
                <svg
                  className="h-5 w-5 text-black-500"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <line x1="9" y1="6" x2="20" y2="6" />
                  <line x1="9" y1="12" x2="20" y2="12" />
                  <line x1="9" y1="18" x2="20" y2="18" />
                  <line x1="5" y1="6" x2="5" y2="6.01" />
                  <line x1="5" y1="12" x2="5" y2="12.01" />
                  <line x1="5" y1="18" x2="5" y2="18.01" />
                </svg>
              </span>
            </div>
          </div>
          <RightPanel
            content={content}
            book={selectedBook}
            isAuthenticated={isAuthenticated}
            openSideBar={openSideBar}
          />
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;
